var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1161 5.11612C11.3505 4.8817 11.6685 4.75 12 4.75C12.3315 4.75 12.6495 4.8817 12.8839 5.11612C13.1183 5.35054 13.25 5.66848 13.25 6C13.25 6.33152 13.1183 6.64946 12.8839 6.88388C12.6495 7.1183 12.3315 7.25 12 7.25C11.6685 7.25 11.3505 7.1183 11.1161 6.88388C10.8817 6.64946 10.75 6.33152 10.75 6C10.75 5.66848 10.8817 5.35054 11.1161 5.11612ZM11.1161 11.1161C11.3505 10.8817 11.6685 10.75 12 10.75C12.3315 10.75 12.6495 10.8817 12.8839 11.1161C13.1183 11.3505 13.25 11.6685 13.25 12C13.25 12.3315 13.1183 12.6495 12.8839 12.8839C12.6495 13.1183 12.3315 13.25 12 13.25C11.6685 13.25 11.3505 13.1183 11.1161 12.8839C10.8817 12.6495 10.75 12.3315 10.75 12C10.75 11.6685 10.8817 11.3505 11.1161 11.1161ZM11.1161 17.1161C11.3505 16.8817 11.6685 16.75 12 16.75C12.3315 16.75 12.6495 16.8817 12.8839 17.1161C13.1183 17.3505 13.25 17.6685 13.25 18C13.25 18.3315 13.1183 18.6495 12.8839 18.8839C12.6495 19.1183 12.3315 19.25 12 19.25C11.6685 19.25 11.3505 19.1183 11.1161 18.8839C10.8817 18.6495 10.75 18.3315 10.75 18C10.75 17.6685 10.8817 17.3505 11.1161 17.1161Z",
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpDots);
export default __webpack_public_path__ + "static/media/op-dots.bed7b71a037a8e5444f640f3e3a6dffe.svg";
export { ForwardRef as ReactComponent };